import { render, staticRenderFns } from "./equityAllocation.vue?vue&type=template&id=fac60ff4&scoped=true"
import script from "./equityAllocation.vue?vue&type=script&lang=js"
export * from "./equityAllocation.vue?vue&type=script&lang=js"
import style0 from "./equityAllocation.vue?vue&type=style&index=0&id=fac60ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac60ff4",
  null
  
)

export default component.exports